// components/StatusBadge.jsx
import React from "react";
import { Chip } from "@mui/material";

const STATUS_COLORS = {
    approved: "success.main",
    rejected: "error.main",
    pending: "grey.500",
    active: "success.main",
    inactive: "error.main",
    completed: "success.main",

};

const StatusBadge = ({ status }) => {
    if (!status) return "-";

    const normalizedStatus = String(status).toLowerCase();
    const color = STATUS_COLORS[normalizedStatus] || STATUS_COLORS.pending;

    return (
        <Chip
            label={normalizedStatus}
            size="small"
            sx={{
                textTransform: "capitalize",
                fontWeight: 600,
                color: "#fff",
                backgroundColor: color,
            }}
        />
    );
};

export default StatusBadge;
